/**
 * Storage key for guest quiz interactions
 * Single source of truth for the localStorage key
 */
export const ONBOARDING_RATINGS_KEY = "onboarding_ratings"

/**
 * Storage key for the ratings count when first unlock was achieved
 * Used as zero point for subsequent level progress calculations
 */
export const FIRST_UNLOCK_COUNT_KEY = "first_unlock_count"

/**
 * Legacy storage key for taste profile features (deprecated)
 */
export const TASTE_PROFILE_FEATURES_KEY = "onboarding_taste_profile_features"
